import { render, staticRenderFns } from "./LicenseCreate.vue?vue&type=template&id=5665c221&scoped=true&"
import script from "./LicenseCreate.vue?vue&type=script&lang=js&"
export * from "./LicenseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665c221",
  null
  
)

export default component.exports